import useResetPassword from "./useResetPassword"
import { Input } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import { MdOutlineAutoGraph } from "react-icons/md";
import Loading from "../../components/loading/Loading";
import { useEffect, useState } from "react";

const ResetPassword = () => {
    const {
        resetPasswordHandler, 
        onChangeHandler, 
        payload,
        loadingPagestate,
        resetError,
        resetErrorMessage
    } = useResetPassword()
    const params = useParams()
    const navigate = useNavigate()
    const [passwordResetMessage, setPasswordResetMessage] = useState('')

    useEffect(() => {
        // Check if there's a password reset message from login
        const message = sessionStorage.getItem('passwordResetMessage')
        if (message) {
            setPasswordResetMessage(message)
            // Clear it from sessionStorage after reading
            sessionStorage.removeItem('passwordResetMessage')
        }
    }, [])

    return(
        <div className="container-fluid" style={{ height: "100vh", position: 'relative', overflow: 'hidden' }}>
            <Loading state={loadingPagestate}/>
            
            {/* Logo positioned at top right */}
            <div style={{
                position: 'absolute',
                top: '32px',
                right: '32px',
                zIndex: 10
            }}>
                <img 
                    src="/logo_gowin.png" 
                    alt="Gowin Logo" 
                    style={{ 
                        height: '52px',
                        width: 'auto'
                    }}
                />
            </div>
            
            <div className="row h-100 g-0">
                <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-center left-login" style={{ padding: '40px 60px' }}>
                    <div style={{ maxWidth: '460px', width: '100%' }}>
                        {/* Title Section */}
                        <div className="d-flex justify-content-start align-items-center mb-5">
                            <MdOutlineAutoGraph style={{fontSize: '56px', marginRight: '16px', color: "#1890ff"}}/>
                            <h2 style={{ 
                                fontWeight: '700', 
                                fontSize: '32px',
                                margin: 0,
                                color: '#1a1a1a',
                                letterSpacing: '-0.5px'
                            }}>
                                Calibration System
                            </h2>
                        </div>

                        {/* Back to Login Button */}
                        <button
                            onClick={() => navigate('/login')}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#6b7280',
                                fontSize: '14px',
                                fontWeight: '500',
                                cursor: 'pointer',
                                padding: '8px 0',
                                marginBottom: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'color 0.2s'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#1890ff'}
                            onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                        >
                            <span>←</span> Back to login
                        </button>

                        {/* Reset Password Content */}
                        <div style={{ marginBottom: '40px' }}>
                            <h3 style={{ 
                                fontSize: '24px', 
                                fontWeight: '600', 
                                color: '#1a1a1a',
                                marginBottom: '8px'
                            }}>
                                Create New Password
                            </h3>
                            <p style={{ 
                                fontSize: '15px', 
                                color: '#6b7280',
                                margin: 0,
                                lineHeight: '1.5'
                            }}>
                                Please enter your new password below
                            </p>
                        </div>

                        {/* Password Reset Required Message */}
                        {passwordResetMessage && (
                            <div style={{
                                padding: '12px 16px',
                                backgroundColor: '#fef3c7',
                                borderLeft: '4px solid #f59e0b',
                                borderRadius: '6px',
                                marginBottom: '24px'
                            }}>
                                <p style={{
                                    color: '#92400e',
                                    fontSize: '14px',
                                    margin: 0,
                                    lineHeight: '1.5',
                                    fontWeight: '500'
                                }}>
                                    {passwordResetMessage}
                                </p>
                            </div>
                        )}

                        {/* Error Message */}
                        {resetError && (
                            <div style={{
                                padding: '12px 16px',
                                backgroundColor: '#fee2e2',
                                borderLeft: '4px solid #ef4444',
                                borderRadius: '6px',
                                marginBottom: '24px'
                            }}>
                                <p style={{
                                    color: '#dc2626', 
                                    fontSize: '14px',
                                    margin: 0,
                                    lineHeight: '1.5',
                                    fontWeight: '500'
                                }}>
                                    {resetErrorMessage}
                                </p>
                            </div>
                        )}

                        {/* Reset Password Form */}
                        <form onSubmit={(e) => {
                            e.preventDefault()
                            if (payload.password && payload.confirmPassword) {
                                resetPasswordHandler(params.email, params.resetToken, payload)
                            }
                        }}>
                            <div style={{ marginBottom: '24px' }}>
                                <label 
                                    htmlFor="password" 
                                    style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '8px'
                                    }}
                                >
                                    New Password
                                </label>
                                <Input.Password
                                    required
                                    className="login-form"
                                    id="password"
                                    name="password"
                                    placeholder="Enter your new password"
                                    onChange={(e) => onChangeHandler(e)}
                                    style={{
                                        height: '44px',
                                        fontSize: '15px',
                                        borderRadius: '8px'
                                    }}
                                />
                            </div>

                            <div style={{ marginBottom: '28px' }}>
                                <label 
                                    htmlFor="confirmPassword" 
                                    style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '8px'
                                    }}
                                >
                                    Confirm New Password
                                </label>      
                                <Input.Password
                                    required
                                    className="login-form"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    placeholder="Confirm your new password"
                                    onChange={(e)=>onChangeHandler(e)}
                                    style={{
                                        height: '44px',
                                        fontSize: '15px',
                                        borderRadius: '8px'
                                    }}
                                />
                            </div>

                            <button
                                type="submit"
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    borderRadius: '8px',
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #02B4CC 0%, #0284C7 100%)',
                                    color: 'white',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 2px 4px rgba(2, 180, 204, 0.2)'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)'
                                    e.target.style.boxShadow = '0 4px 8px rgba(2, 180, 204, 0.3)'
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)'
                                    e.target.style.boxShadow = '0 2px 4px rgba(2, 180, 204, 0.2)'
                                }}
                            >
                                Reset Password
                            </button>
                        </form>

                        {/* Password Requirements */}
                        {/* <div style={{
                            marginTop: '24px',
                            padding: '12px 16px',
                            backgroundColor: '#f0f9ff',
                            borderRadius: '6px',
                            borderLeft: '4px solid #1890ff'
                        }}>
                            <p style={{
                                fontSize: '13px',
                                color: '#374151',
                                margin: 0,
                                marginBottom: '8px',
                                fontWeight: '600'
                            }}>
                                Password Requirements:
                            </p>
                            <ul style={{
                                fontSize: '12px',
                                color: '#6b7280',
                                margin: 0,
                                paddingLeft: '20px',
                                lineHeight: '1.8'
                            }}>
                                <li>At least 8 characters long</li>
                                <li>Contains uppercase and lowercase letters</li>
                                <li>Includes at least one number</li>
                            </ul>
                        </div> */}
                    </div>
                </div>

                {/* Right Side - Decorative */}
                <div className="col-lg-6 d-none d-lg-flex flex-column justify-content-center align-items-center right-login" style={{
                    background: 'linear-gradient(to bottom right, #02B4CC 0%, #0284C7 100%)',
                    position: 'relative'
                }}>    
                    <div style={{ position: 'relative', zIndex: 1 }}>
                        <MdOutlineAutoGraph style={{
                            fontSize: '320px', 
                            color: "rgba(255, 255, 255, 0.15)",
                            filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.1))'
                        }}/>
                    </div>
                    <h3 style={{
                        color: 'white',
                        fontSize: '28px',
                        fontWeight: '600',
                        marginTop: '40px',
                        textAlign: 'center',
                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}>
                        Secure Your Account
                    </h3>
                    <p style={{
                        color: 'rgba(255, 255, 255, 0.9)',
                        fontSize: '16px',
                        textAlign: 'center',
                        maxWidth: '400px',
                        lineHeight: '1.6',
                        marginTop: '12px'
                    }}>
                        Choose a strong password to protect your calibration data and maintain system integrity
                    </p>
                </div>
            </div>
        </div>
    )
}

export default ResetPassword